import { type UseQueryResult, useQuery } from 'react-query';
import { GovernmentDocumentTypeService } from '../../services/wealthlane-customer-services';

const useGetGovernmentDocumentType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const GovernmentDocumentTypesList = useQuery(
    ['getGovernmentDocumentTypesList'],
    async () => {
      return await handleRequest(
        GovernmentDocumentTypeService.getApiCustomerApiAppGovernmentDocumentTypeGovernmentDocumentTypesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return GovernmentDocumentTypesList;
};

export default useGetGovernmentDocumentType;
